export default "__VITE_ASSET__05f99509__"